/**
 * Attribute ChatGPT / AI assistant referral traffic for GA4 / dataLayer.
 */
(function () {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = document.referrer || '';
    const hosts = ['chatgpt.com', 'chat.openai.com', 'perplexity.ai', 'claude.ai', 'gemini.google.com'];
    const fromParam = (params.get('utm_source') || '').toLowerCase();
    const fromRef = hosts.find((h) => ref.includes(h));
    const source = fromParam || (fromRef ? fromRef.replace('.google.com', '') : '');

    if (!source) return;

    const payload = {
      event: 'ai_assistant_referral',
      ai_source: source,
      ai_referrer: ref || undefined,
      page_path: window.location.pathname,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try {
      sessionStorage.setItem('bbl_ai_source', source);
    } catch (e) {
      /* ignore */
    }
  } catch (e) {
    /* ignore */
  }
})();
